import styled from 'styled-components';
import { Table } from 'antd';
import { COLORS } from '../../constants/colors';

export const PageContainer = styled.div`
  padding: 24px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #2C3E50;
  margin: 0;
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const StyledTable = styled(Table)`
  background: white;
  border-radius: 16px;
  border: 1px solid #f0f0f0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .ant-table {
    border-radius: 0;
    overflow: hidden;
    background: white;
    border: none;
  }
  
  .ant-table-thead > tr > th {
    background: white !important;
    color: ${COLORS.textDark} !important;
    border-bottom: 3px solid ${COLORS.$primaryBlue} !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 52px !important;
    padding: 14px 20px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    position: relative;
    
    &:first-child {
      border-top-left-radius: 16px;
    }
    
    &:last-child {
      border-top-right-radius: 16px;
    }
  }
  
  .ant-table-tbody > tr {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f5f5f5;
    
    &:hover > td {
      background: #fafbff !important;
      transform: translateY(-1px);
    }
    
    &:last-child {
      border-bottom: none;
      
      td {
        border-bottom: none;
      }
    }
    
    &:nth-child(even) {
      background: #fafafa;
      
      &:hover > td {
        background: #f0f7ff !important;
      }
    }
  }
  
  .ant-table-tbody > tr > td {
    border-bottom: none;
    padding: 18px 20px;
    font-size: 14px;
    line-height: 1.5;
    vertical-align: middle;
    text-align: left;
    transition: all 0.2s ease;
  }
  
  /* Pagination styling */
  .ant-pagination {
    margin: 0 !important;
    padding: 12px 16px !important;
    border-top: 1px solid ${COLORS.border};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    
    .ant-pagination-total-text {
      font-size: 13px;
      color: ${COLORS.textMedium};
      font-weight: 500;
      flex: 1;
    }
    
    .ant-pagination-options {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 32px;
      
      .ant-pagination-options-size-changer {
        height: 32px !important;
        
        .ant-select-selector {
          border-radius: 16px !important;
          border: 1.5px solid ${COLORS.border} !important;
          height: 32px !important;
          min-height: 32px !important;
          min-width: 100px !important;
          transition: all 0.3s ease !important;
          display: flex !important;
          align-items: center !important;
          padding: 0 28px 0 12px !important;
          box-sizing: border-box !important;
          
          &:hover {
            border-color: ${COLORS.$primaryBlue} !important;
            box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15) !important;
          }
        }
        
        .ant-select-selection-item {
          height: 28px !important;
          line-height: 28px !important;
          padding: 0 !important;
          display: flex !important;
          align-items: center !important;
          font-weight: 500 !important;
          font-size: 13px !important;
          flex: 1 !important;
          min-width: 0 !important;
        }
        
        .ant-select-selection-search {
          height: 28px !important;
          padding-left: 8px !important;
          
          .ant-select-selection-search-input {
            height: 28px !important;
            line-height: 28px !important;
          }
        }
        
        .ant-select-arrow {
          right: 10px !important;
          flex-shrink: 0 !important;
          height: 14px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          
          .anticon {
            line-height: 1 !important;
            vertical-align: middle !important;
          }
        }
        
        &.ant-select-focused .ant-select-selector {
          border-color: ${COLORS.$primaryBlue} !important;
          box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15) !important;
        }
      }
      
      .ant-pagination-options-quick-jumper {
        display: flex;
        align-items: center;
        height: 32px;
        font-size: 13px;
        
        .ant-input {
          border-radius: 16px !important;
          border: 1.5px solid ${COLORS.border} !important;
          height: 32px !important;
          min-height: 32px !important;
          width: 50px !important;
          text-align: center;
          font-weight: 600;
          font-size: 13px;
          transition: all 0.3s ease !important;
          line-height: 28px !important;
          padding: 0 0 0 8px !important;
          
          &:hover {
            border-color: ${COLORS.$primaryBlue} !important;
            box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15) !important;
          }
          
          &:focus {
            border-color: ${COLORS.$primaryBlue} !important;
            box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15) !important;
          }
        }
      }
    }
    
    .ant-pagination-item {
      border-radius: 50% !important;
      border: 1.5px solid ${COLORS.border};
      min-width: 32px !important;
      height: 32px !important;
      line-height: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      a {
        color: ${COLORS.textDark};
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-decoration: none;
        font-size: 13px;
      }
      
      &:hover {
        border-color: ${COLORS.$primaryBlue};
        background: rgba(24, 144, 255, 0.1);
        transform: translateY(-1px);
        
        a {
          color: ${COLORS.$primaryBlue};
        }
      }
      
      &.ant-pagination-item-active {
        background: ${COLORS.$primaryBlue};
        border-color: ${COLORS.$primaryBlue};
        transform: translateY(-1px);
        
        a {
          color: white;
          font-weight: 700;
        }
        
        &:hover {
          background: ${COLORS.$primaryBlueDark};
          border-color: ${COLORS.$primaryBlueDark};
          
          a {
            color: white;
          }
        }
      }
    }
    
    .ant-pagination-prev,
    .ant-pagination-next {
      border-radius: 50% !important;
      border: 1.5px solid ${COLORS.border};
      min-width: 32px !important;
      height: 32px !important;
      line-height: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      .anticon {
        color: ${COLORS.textDark};
        font-size: 14px;
      }
      
      &:hover {
        border-color: ${COLORS.$primaryBlue};
        background: rgba(24, 144, 255, 0.1);
        transform: translateY(-1px);
        
        .anticon {
          color: ${COLORS.$primaryBlue};
        }
      }
      
      &.ant-pagination-disabled {
        border-color: #e8e8e8;
        background: #f5f5f5;
        
        .anticon {
          color: ${COLORS.textMuted};
        }
        
        &:hover {
          border-color: #e8e8e8;
          background: #f5f5f5;
          transform: none;
          
          .anticon {
            color: ${COLORS.textMuted};
          }
        }
      }
    }
    
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      border-radius: 50% !important;
      border: 1.5px solid ${COLORS.border};
      min-width: 32px !important;
      height: 32px !important;
      line-height: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      .anticon {
        color: ${COLORS.textMuted};
        font-size: 14px;
      }
      
      &:hover {
        border-color: ${COLORS.$primaryBlue};
        background: rgba(24, 144, 255, 0.1);
        transform: translateY(-1px);
        
        .anticon {
          color: ${COLORS.$primaryBlue};
        }
      }
    }
  }
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  h3 {
    font-size: 28px;
    font-weight: 700;
    color: ${props => props.$color || '#4A90E2'};
    margin: 0 0 4px 0;
  }
  
  p {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
`;

export const SignaturePreview = styled.div`
  max-width: 300px;
  margin-top: 8px;
  
  img {
    max-width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: white;
  }
  
  .typed-signature {
    font-family: 'Brush Script MT', cursive;
    font-size: 28px;
    color: #1a365d;
    padding: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: white;
  }
`;

export const AcknowledgmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AcknowledgmentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  .icon {
    color: ${props => props.$acknowledged ? '#52c41a' : '#ff4d4f'};
  }
`;
